import { createSlice } from "@reduxjs/toolkit"
import type { PayloadAction } from "@reduxjs/toolkit"
import type { MenuCatalogSnapshot } from "@/domain/cart/cart-validity.types"
import { MenuItemInterface } from "@/models/menu-item"

export interface MenuItemsInterface {
  list: MenuItemInterface[]
  fetching: boolean
  /** Latest catalog snapshot + fingerprint from the most recent successful fetch. */
  catalogSnapshot: MenuCatalogSnapshot | null
}

const initialState: MenuItemsInterface = {
  list: [],
  fetching: true,
  catalogSnapshot: null,
}

export const menuItemsSlice = createSlice({
  name: "menuItems",
  initialState,
  reducers: {
    updateMenuItems: (state, action: PayloadAction<Partial<MenuItemsInterface>>) => {
      if (action.payload.list !== undefined) {
        state.list = action.payload.list
      }
      if (action.payload.fetching !== undefined) {
        state.fetching = action.payload.fetching
      }
      if (action.payload.catalogSnapshot !== undefined) {
        state.catalogSnapshot = action.payload.catalogSnapshot
      }
    },

    // ✅ New reducer to reset all item counts to 0
    resetMenuItemCounts: (state) => {
      state.list = state.list.map(item => ({
        ...item,
        count: 0,
      }))
    },
  },
})

// ✅ Export both actions
export const { updateMenuItems, resetMenuItemCounts } = menuItemsSlice.actions

export default menuItemsSlice.reducer